export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5491.eccc3f17.jpg";